import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en.json';
import fiTranslation from './locales/fi.json';
import svTranslation from './locales/sv.json';
import evidence from './evidence';

const resources = {
  en: {
    translation: { ...enTranslation, evidence: evidence.en }
  },
  fi: {
    translation: { ...fiTranslation, evidence: evidence.fi }
  },
    sv: {
      translation: { ...svTranslation, evidence: evidence.sv }
    }
};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV && import.meta.env.VITE_I18N_DEBUG === 'true',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // 'querystring' first so that tendera.fi's ?lang=fi|en|sv actually decides the language when a
      // visitor arrives from a language version of the marketing site. Without it the app ignored the
      // parameter entirely and always fell back to localStorage or the browser locale.
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      caches: ['localStorage'],
    }
  });

// Keeps <html lang> in sync with whatever language is actually active, regardless of where the
// change was triggered (onboarding, the top-nav language switcher, etc.) -- index.html declares
// a static lang="fi" that never otherwise updates, which is exactly the kind of declared-vs-actual
// content mismatch that makes browsers offer to auto-translate the page.
const syncDocumentLang = (lng) => {
  document.documentElement.lang = lng?.split('-')[0] || 'en';
};
syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
